<template>
  <section class="dp-layout parking-page parking-temp-page">
    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" :searchList="searchList" @callFunction="callFunction"></toolbar>

      <div class="parking-stat-wrap">
        <div class="parking-stat-cards" :class="{ 'is-summary-loading': summaryLoading }">
          <div class="parking-stat-card stat-total clickable" :class="{ active: status === '' }" @click="quickFilter('')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-s-data"></i></span>
              <span class="stat-card-label">申请总数</span>
            </div>
            <div class="stat-card-value">{{ summary.totalCount }}</div>
          </div>
          <div class="parking-stat-card stat-update clickable" :class="{ active: status === 'Pending' }" @click="quickFilter('Pending')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-time"></i></span>
              <span class="stat-card-label">待审批</span>
            </div>
            <div class="stat-card-value">{{ summary.pendingCount }}</div>
          </div>
          <div class="parking-stat-card stat-synced clickable" :class="{ active: status === 'Approved' }" @click="quickFilter('Approved')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-circle-check"></i></span>
              <span class="stat-card-label">已生效</span>
            </div>
            <div class="stat-card-value">{{ summary.approvedCount }}</div>
          </div>
          <div class="parking-stat-card stat-failed clickable" :class="{ active: status === 'Rejected' }" @click="quickFilter('Rejected')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-circle-close"></i></span>
              <span class="stat-card-label">已驳回/取消</span>
            </div>
            <div class="stat-card-value">{{ summary.rejectedCount }}</div>
          </div>
          <div class="parking-stat-card stat-pending clickable" :class="{ active: status === 'Expired' }" @click="quickFilter('Expired')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-alarm-clock"></i></span>
              <span class="stat-card-label">
                已过期
                <el-tooltip content="到期后由定时任务自动回收，并通知车场系统删除白名单。" placement="top">
                  <i class="el-icon-question stat-tip-icon"></i>
                </el-tooltip>
              </span>
            </div>
            <div class="stat-card-value">{{ summary.expiredCount }}</div>
          </div>
        </div>
      </div>

      <div class="parking-table-panel">
        <div class="panel-header">
          <div class="panel-title">临时车申请<span class="count">共 {{ total }} 条</span></div>
          <span class="panel-tip">后台审批会一次性完成所有未处理节点；访客邀请提交后直接生效</span>
        </div>

        <div class="tbl-scroll-host">
          <el-table :data="rows" v-loading="listLoading" class="custom-tbl" style="width:100%" height="100%">
            <el-table-column type="index" label="序号" width="60" :index="rowIndex"></el-table-column>
            <el-table-column label="来源" width="80">
              <template slot-scope="scope">
                <span :class="['subject-tag', scope.row.sourceType === 2 ? 'is-visitor' : 'is-parent']">
                  {{ scope.row.sourceType === 2 ? '访客' : '家长' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="申请人" min-width="140">
              <template slot-scope="scope">
                <template v-if="scope.row.sourceType === 2">
                  {{ scope.row.visitorName || '-' }}
                  <span v-if="scope.row.visitorMobile" class="sub-text">{{ scope.row.visitorMobile }}</span>
                </template>
                <template v-else>
                  {{ scope.row.studentName || '-' }}
                  <span class="sub-text">学生家长</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="车牌号" width="130">
              <template slot-scope="scope"><span class="plate-no-badge">{{ scope.row.plateNo }}</span></template>
            </el-table-column>
            <el-table-column label="事由" min-width="160" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.reason || '-' }}</template>
            </el-table-column>
            <el-table-column label="有效时段" width="180">
              <template slot-scope="scope">
                <span class="time-text">{{ formatDateTime(scope.row.startTime) }}</span>
                <span class="sub-text">至 {{ formatDateTime(scope.row.endTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="90">
              <template slot-scope="scope">
                <el-tag :type="statusOf(scope.row.status).type" size="small">{{ statusOf(scope.row.status).label }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="审批信息" min-width="180">
              <template slot-scope="scope">
                <template v-if="scope.row.status === 'Pending'">
                  <span v-if="scope.row.currentApproverName">待 {{ scope.row.currentApproverName }} 审批</span>
                  <span v-else class="text-muted">待审批</span>
                </template>
                <template v-else>
                  {{ scope.row.approverName || '-' }}
                  <span v-if="scope.row.approveTime" class="sub-text">{{ formatDateTime(scope.row.approveTime) }}</span>
                  <span v-if="scope.row.rejectReason" class="sub-text">原因：{{ scope.row.rejectReason }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="提交时间" width="150">
              <template slot-scope="scope"><span class="time-text">{{ formatDateTime(scope.row.createTime) }}</span></template>
            </el-table-column>
            <el-table-column v-if="can('audit')" label="操作" width="160" fixed="right" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.status === 'Pending'" class="table-op-pair">
                  <el-button type="text" class="table-op-link" @click="audit(scope.row, true)">通过</el-button>
                  <el-button type="text" class="table-op-link table-op-link--danger" @click="audit(scope.row, false)">驳回</el-button>
                </div>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-col :span="24" class="toolbar">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="float:right"
          ></el-pagination>
        </el-col>
      </div>
    </section>

    <!-- 生成访客邀请 -->
    <el-dialog title="生成访客邀请" :visible.sync="inviteFormVisible" width="560px" append-to-body :close-on-click-modal="false">
      <el-form ref="inviteForm" :model="invite" :rules="inviteRules" label-width="110px" size="small">
        <el-form-item label="来访事由" prop="reason">
          <el-input v-model="invite.reason" maxlength="100" placeholder="如：家长会、校际交流"></el-input>
        </el-form-item>
        <el-form-item label="时长模式">
          <el-radio-group v-model="invite.durationMode">
            <el-radio label="Fixed">固定时段</el-radio>
            <el-radio label="MaxRange">访客自填</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="invite.durationMode === 'Fixed'" label="固定时段" prop="fixedRange">
          <el-date-picker
            v-model="invite.fixedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width:100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-else label="最大时长(天)">
          <el-input-number v-model="invite.maxDays" :min="1" :max="365" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="链接失效时间" prop="expireAt">
          <el-date-picker v-model="invite.expireAt" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="最大使用次数">
          <el-input-number v-model="invite.maxUses" :min="1" :max="1000" controls-position="right"></el-input-number>
          <div class="parking-form-tip">每位访客提交一次计 1 次，用完后链接自动失效</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="inviteFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="creating" @click="createInvite">生成邀请</el-button>
      </span>
    </el-dialog>

    <!-- 邀请生成结果 -->
    <el-dialog :title="inviteResultTitle" :visible.sync="inviteResultVisible" width="460px" append-to-body :close-on-click-modal="false">
      <div v-if="inviteUrl" class="invite-result">
        <canvas ref="qrCanvas" class="qr-canvas"></canvas>
        <el-input v-model="inviteUrl" readonly size="small">
          <el-button slot="append" icon="el-icon-document-copy" @click="copyUrl(inviteUrl)">复制</el-button>
        </el-input>
        <div class="parking-form-tip">将链接或二维码发给访客；之后也可在「邀请记录」中再次复制。</div>
      </div>
      <el-alert
        v-else
        type="warning"
        :closable="false"
        show-icon
        title="邀请已生成，但未配置访客 H5 地址"
        description="请到「对接配置 → 临时车 → 访客临时车」填写访客 H5 地址并保存，之后可在「邀请记录」中复制链接和二维码。"
      ></el-alert>
      <span slot="footer">
        <el-button type="primary" @click="inviteResultVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 邀请记录 -->
    <el-dialog title="访客邀请记录" :visible.sync="inviteListVisible" width="1120px" top="8vh" append-to-body :close-on-click-modal="false" custom-class="invite-list-dialog">
      <el-table :data="invites" v-loading="inviteLoading" class="custom-tbl" height="460" size="small">
        <el-table-column type="index" label="序号" width="55" :index="inviteIndex"></el-table-column>
        <el-table-column prop="reason" label="来访事由" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="时长" min-width="170">
          <template slot-scope="scope">
            <template v-if="scope.row.durationMode === 'Fixed'">
              {{ formatDateTime(scope.row.fixedStart) }}
              <span class="sub-text">至 {{ formatDateTime(scope.row.fixedEnd) }}</span>
            </template>
            <template v-else>访客自填，最长 {{ scope.row.maxDays }} 天</template>
          </template>
        </el-table-column>
        <el-table-column label="使用次数" width="80" align="center">
          <template slot-scope="scope">{{ scope.row.usedCount }}/{{ scope.row.maxUses }}</template>
        </el-table-column>
        <el-table-column label="失效时间" width="140">
          <template slot-scope="scope">{{ formatDateTime(scope.row.expireAt) }}</template>
        </el-table-column>
        <el-table-column label="创建人" width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.createdByName || '-' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="76" align="center">
          <template slot-scope="scope">
            <el-tag :type="inviteState(scope.row).type" size="mini">{{ inviteState(scope.row).label }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="230" align="center">
          <template slot-scope="scope">
            <div class="invite-ops">
              <template v-if="inviteState(scope.row).active">
                <template v-if="scope.row.inviteUrl">
                  <el-button type="text" size="small" @click="copyUrl(scope.row.inviteUrl)">复制链接</el-button>
                  <el-button type="text" size="small" @click="showInviteResult(scope.row.inviteUrl, '访客邀请二维码')">二维码</el-button>
                </template>
                <el-tooltip
                  v-else
                  :content="scope.row.token ? '未配置访客 H5 地址，请到对接配置的「临时车」中填写' : '历史邀请未保存链接，如需补发请重新生成'"
                  placement="top"
                >
                  <span class="text-muted">不可复制</span>
                </el-tooltip>
                <el-button v-if="can('disableInvite')" type="text" size="small" class="is-warning" @click="disableInvite(scope.row)">禁用</el-button>
              </template>
              <el-button v-if="canEnableInvite(scope.row)" type="text" size="small" @click="enableInvite(scope.row)">启用</el-button>
              <el-button v-if="canDeleteInvite(scope.row)" type="text" size="small" class="is-danger" @click="deleteInvite(scope.row)">删除</el-button>
              <span v-if="!hasInviteOps(scope.row)" class="text-muted">-</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="invite-pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :current-page="invitePage"
          :page-sizes="pageSizes"
          :page-size="invitePageSize"
          :total="inviteTotal"
          @size-change="handleInviteSizeChange"
          @current-change="handleInvitePageChange"
        ></el-pagination>
      </div>
    </el-dialog>

    <!-- 临时车审批流程 -->
    <el-dialog title="临时车审批流程设置" :visible.sync="flowVisible" width="860px" append-to-body :close-on-click-modal="false">
      <el-alert
        type="info"
        :closable="false"
        show-icon
        title="家长提交临时车后按节点顺序审批，同一节点任一人通过即进入下一节点，全部通过后下发道闸。"
        description="「班主任」指学生所在班级的班主任；班主任代家长提交时自动跳过本人。未配置流程时家长无法提交临时车申请。"
      ></el-alert>
      <el-table :data="flowNodes" v-loading="flowLoading" size="small" class="custom-tbl flow-node-table">
        <el-table-column type="index" label="节点" width="60" align="center"></el-table-column>
        <el-table-column label="审批人">
          <template slot-scope="scope">
            <div class="flow-node-row">
              <el-select v-model="scope.row.role" size="small" style="width: 120px;" @change="flowRoleChange(scope.row)">
                <el-option
                  v-for="item in flowRoleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.value === 'classTeacher' && scope.row.role !== 'classTeacher' && hasClassTeacherNode"
                ></el-option>
              </el-select>
              <el-select
                v-if="scope.row.role === 'specificPerson'"
                v-model="scope.row.specificUsers"
                size="small"
                multiple
                filterable
                placeholder="请选择审批人"
                style="flex: 1; min-width: 260px;"
                @change="flowUsersChange(scope.row)"
              >
                <el-option v-for="user in flowTeachers" :key="String(user.Id)" :label="user.TeacherName" :value="String(user.Id)"></el-option>
              </el-select>
              <el-input v-model="scope.row.nodeName" size="small" placeholder="节点名称" style="width: 180px;"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="is-danger" @click="removeFlowNode(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="addFlowNode">添加节点</el-button>
        <el-button @click="flowVisible = false">取消</el-button>
        <el-button type="primary" :loading="flowSaving" @click="saveApprovalFlow">保存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import QRCode from 'qrcode'
import Toolbar from '@/components/Toolbar'
import {
  getParkingTempApplicationPage,
  getParkingTempSummary,
  auditParkingTempVehicle,
  createParkingTempInvite,
  getParkingTempInvitePage,
  disableParkingTempInvite,
  enableParkingTempInvite,
  deleteParkingTempInvite
} from '@/api/parking'
import { getLeaveApprovalProcessListPage, addLeaveApprovalProcess, getProcessOfficer, addProcessOfficer } from '@/api/modules/misc'
import { getTeacherMasterList } from '@/api/modules/personnel'
import { toCamel, readPage, formatDateTime, tempStatusMap, loadButtonFuncs, buildToolbarButtons } from './parkingUtils'

const TOOLBAR_BUTTONS = [
  { name: '查询', Func: 'handleSearchBtn', icon: 'el-icon-search', always: true },
  { name: '新增访客邀请', Func: 'openInviteForm', icon: 'el-icon-share', btnType: 'primary' },
  { name: '邀请记录', Func: 'openInviteList', icon: 'el-icon-tickets' },
  { name: '审批流程设置', Func: 'openApprovalFlow', icon: 'el-icon-s-operation' }
]

const TEMP_FLOW_USING_TYPE = 'parking_temp_vehicle'

export default {
  name: 'ParkingTempVehicle',
  components: { Toolbar },
  data() {
    return {
      schoolId: null,
      listLoading: false,
      summaryLoading: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      keyword: '',
      sourceType: 0,
      status: 'Pending',
      summary: { totalCount: 0, pendingCount: 0, approvedCount: 0, rejectedCount: 0, expiredCount: 0 },
      inviteFormVisible: false,
      inviteResultVisible: false,
      inviteListVisible: false,
      creating: false,
      invite: this.emptyInvite(),
      inviteRules: {
        reason: [{ required: true, message: '请填写来访事由', trigger: 'blur' }],
        fixedRange: [{ required: true, type: 'array', message: '请选择固定时段', trigger: 'change' }],
        expireAt: [{ required: true, message: '请选择链接失效时间', trigger: 'change' }]
      },
      inviteUrl: '',
      inviteResultTitle: '邀请已生成',
      invites: [],
      inviteLoading: false,
      invitePage: 1,
      invitePageSize: 10,
      inviteTotal: 0,
      flowVisible: false,
      flowLoading: false,
      flowSaving: false,
      flowProcessId: '',
      flowNodes: [],
      flowTeachers: [],
      flowRoleOptions: [
        { label: '班主任', value: 'classTeacher' },
        { label: '指定人员', value: 'specificPerson' }
      ],
      buttonFuncs: [],
      buttonList: [],
      searchList: [
        { key: 'keyword', label: '关键字', placeholder: '车牌/访客/提交人', width: '170px' },
        {
          key: 'sourceType', label: '来源', type: 'select', clearable: true, initValue: 0, width: '100px',
          options: [
            { value: 0, label: '全部' },
            { value: 1, label: '家长' },
            { value: 2, label: '访客' }
          ]
        },
        {
          key: 'status', label: '状态', type: 'select', clearable: true, initValue: 'Pending', width: '110px',
          options: [
            { value: '', label: '全部' },
            { value: 'Pending', label: '待审批' },
            { value: 'Approved', label: '已生效' },
            { value: 'Rejected', label: '已驳回' },
            { value: 'Expired', label: '已过期' }
          ]
        }
      ]
    }
  },
  watch: {
    '$store.state.activeSchoolId': {
      immediate: true,
      handler(value) {
        this.schoolId = value
        this.page = 1
        if (value) this.loadData()
      }
    }
  },
  computed: {
    hasClassTeacherNode() {
      return this.flowNodes.some(n => n.role === 'classTeacher')
    }
  },
  created() {
    this.buttonFuncs = loadButtonFuncs(this.$route.path)
    this.buttonList = buildToolbarButtons(TOOLBAR_BUTTONS, this.buttonFuncs)
  },
  methods: {
    formatDateTime,
    /** 当前角色是否分配了该按钮权限 */
    can(func) {
      return this.buttonFuncs.includes(func)
    },
    callFunction(item) {
      if (item.Func && typeof this[item.Func] === 'function') this[item.Func](item)
    },
    emptyInvite() {
      return { reason: '', durationMode: 'Fixed', fixedRange: [], maxDays: 1, expireAt: '', maxUses: 1 }
    },
    statusOf(status) {
      return tempStatusMap[status] || { label: status || '-', type: 'info' }
    },
    rowIndex(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    inviteIndex(index) {
      return (this.invitePage - 1) * this.invitePageSize + index + 1
    },
    /** 邀请有效状态：禁用 / 过期 / 次数用完 / 有效 */
    inviteState(row) {
      if (!row.enabled) return { label: '已禁用', type: 'info', active: false }
      if (row.expireAt && new Date(row.expireAt) <= new Date()) return { label: '已过期', type: 'info', active: false }
      if (row.usedCount >= row.maxUses) return { label: '已用完', type: 'warning', active: false }
      return { label: '有效', type: 'success', active: true }
    },
    /** 已禁用且未过期、次数未用完的邀请可重新启用。创建于 2026-10-10 */
    canEnableInvite(row) {
      if (!this.can('enableInvite') || row.enabled) return false
      if (row.expireAt && new Date(row.expireAt) <= new Date()) return false
      return row.usedCount < row.maxUses
    },
    /** 未被使用过的邀请可删除；已使用的只能禁用，保留来源追溯。创建于 2026-10-10 */
    canDeleteInvite(row) {
      return this.can('deleteInvite') && !(row.usedCount > 0)
    },
    hasInviteOps(row) {
      return this.inviteState(row).active || this.canEnableInvite(row) || this.canDeleteInvite(row)
    },
    quickFilter(status) {
      if (this.status === status) return
      this.status = status
      this.page = 1
      const toolbar = this.$refs.toolbar
      if (toolbar && toolbar.searchObj) this.$set(toolbar.searchObj, 'status', status)
      this.loadList()
    },
    handleSearchBtn(item) {
      const s = (item && item.search) || {}
      this.keyword = s.keyword || ''
      this.sourceType = s.sourceType || 0
      this.status = s.status || ''
      this.page = 1
      this.loadData()
    },
    loadData() {
      if (!this.schoolId) return
      this.loadSummary()
      this.loadList()
    },
    async loadSummary() {
      this.summaryLoading = true
      try {
        const res = await getParkingTempSummary(this.schoolId)
        if (res.data && res.data.success) {
          this.summary = { ...this.summary, ...toCamel(res.data.response || {}) }
        }
      } catch (e) {
        // 汇总失败不阻断列表
      } finally {
        this.summaryLoading = false
      }
    },
    async loadList() {
      if (!this.schoolId) return
      this.listLoading = true
      try {
        const res = await getParkingTempApplicationPage({
          schoolId: this.schoolId,
          status: this.status,
          sourceType: this.sourceType,
          keyword: this.keyword,
          page: this.page,
          pageSize: this.pageSize
        })
        if (res.data && res.data.success) {
          const { list, total } = readPage(res)
          this.rows = list
          this.total = total
        } else {
          this.$message.error((res.data && res.data.msg) || '临时车列表加载失败')
        }
      } catch (e) {
        this.$message.error('临时车列表加载失败')
      } finally {
        this.listLoading = false
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.loadList()
    },
    /** 审批通过或驳回（驳回需填写原因） */
    async audit(row, approved) {
      const who = row.sourceType === 2 ? row.visitorName : row.studentName
      let opinion = ''
      try {
        if (approved) {
          await this.$confirm(`确定通过「${who || row.plateNo}」的临时车申请吗？通过后按申请时段生效并同步到车场系统。`, '审批通过', { type: 'info' })
        } else {
          const result = await this.$prompt(`驳回「${who || row.plateNo}」的临时车申请`, '驳回申请', {
            inputPlaceholder: '请输入驳回原因',
            inputValidator: v => !!(v && v.trim()) || '请输入驳回原因'
          })
          opinion = result.value.trim()
        }
      } catch (e) {
        return
      }
      const res = await auditParkingTempVehicle({ schoolId: this.schoolId, applicationId: row.id, approved, opinion })
      if (res.data && res.data.success) {
        this.$message.success(res.data.msg || (approved ? '审批通过' : '已驳回'))
        this.loadData()
      } else {
        this.$message.error((res.data && res.data.msg) || '操作失败')
      }
    },
    openInviteForm() {
      if (!this.schoolId) {
        this.$message.warning('请先选择学校')
        return
      }
      this.invite = this.emptyInvite()
      this.inviteFormVisible = true
      this.$nextTick(() => this.$refs.inviteForm && this.$refs.inviteForm.clearValidate())
    },
    /** 固定时段跨越的天数（向上取整），用于后端校验不超过学校配置的最大天数 */
    fixedRangeDays() {
      const [start, end] = this.invite.fixedRange || []
      const ms = new Date(end).getTime() - new Date(start).getTime()
      return Math.max(1, Math.ceil(ms / 86400000))
    },
    createInvite() {
      this.$refs.inviteForm.validate(async valid => {
        if (!valid) return
        const fixed = this.invite.durationMode === 'Fixed'
        this.creating = true
        try {
          const res = await createParkingTempInvite({
            schoolId: this.schoolId,
            campusId: 0,
            reason: this.invite.reason,
            durationMode: this.invite.durationMode,
            fixedStart: fixed ? this.invite.fixedRange[0] : null,
            fixedEnd: fixed ? this.invite.fixedRange[1] : null,
            maxDays: fixed ? this.fixedRangeDays() : this.invite.maxDays,
            expireAt: this.invite.expireAt,
            maxUses: this.invite.maxUses
          })
          if (res.data && res.data.success) {
            const created = toCamel(res.data.response || {})
            this.inviteFormVisible = false
            this.showInviteResult(created.inviteUrl, '邀请已生成')
          } else {
            this.$message.error((res.data && res.data.msg) || '生成失败')
          }
        } finally {
          this.creating = false
        }
      })
    },
    /** 弹出邀请链接与二维码（新建后与邀请记录共用）；链接由后端按学校配置的访客 H5 地址拼接。最后修改：2026-10-10 */
    showInviteResult(url, title) {
      this.inviteUrl = url || ''
      this.inviteResultTitle = title
      this.inviteResultVisible = true
      if (!this.inviteUrl) return
      this.$nextTick(() => QRCode.toCanvas(this.$refs.qrCanvas, this.inviteUrl, { width: 200, margin: 1 }))
    },
    copyUrl(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this.$message.success('链接已复制')).catch(() => this.$message.error('复制失败'))
        return
      }
      const ta = document.createElement('textarea')
      ta.value = text
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success('链接已复制')
      } catch (e) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(ta)
    },
    openInviteList() {
      if (!this.schoolId) {
        this.$message.warning('请先选择学校')
        return
      }
      this.invitePage = 1
      this.inviteListVisible = true
      this.loadInvites()
    },
    async loadInvites() {
      this.inviteLoading = true
      try {
        const res = await getParkingTempInvitePage({ schoolId: this.schoolId, page: this.invitePage, pageSize: this.invitePageSize })
        if (res.data && res.data.success) {
          const { list, total } = readPage(res)
          this.invites = list
          this.inviteTotal = total
        } else {
          this.$message.error((res.data && res.data.msg) || '邀请记录加载失败')
        }
      } finally {
        this.inviteLoading = false
      }
    },
    handleInvitePageChange(val) {
      this.invitePage = val
      this.loadInvites()
    },
    handleInviteSizeChange(val) {
      this.invitePageSize = val
      this.invitePage = 1
      this.loadInvites()
    },
    async disableInvite(row) {
      try {
        await this.$confirm('禁用后访客将无法再通过该链接提交，已提交的申请不受影响。确定禁用吗？', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      const res = await disableParkingTempInvite(this.schoolId, row.id)
      if (res.data && res.data.success) {
        this.$message.success('邀请已禁用')
        this.loadInvites()
      } else {
        this.$message.error((res.data && res.data.msg) || '禁用失败')
      }
    },
    async enableInvite(row) {
      const res = await enableParkingTempInvite(this.schoolId, row.id)
      if (res.data && res.data.success) {
        this.$message.success('邀请已启用')
        this.loadInvites()
      } else {
        this.$message.error((res.data && res.data.msg) || '启用失败')
      }
    },
    async deleteInvite(row) {
      try {
        await this.$confirm('删除后该链接立即失效且不可恢复。确定删除吗？', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      const res = await deleteParkingTempInvite(this.schoolId, row.id)
      if (res.data && res.data.success) {
        this.$message.success('邀请已删除')
        if (this.invites.length === 1 && this.invitePage > 1) this.invitePage -= 1
        this.loadInvites()
      } else {
        this.$message.error((res.data && res.data.msg) || '删除失败')
      }
    },
    /** 打开临时车审批流程：读取本校 parking_temp_vehicle 流程（取序号最小一条，与 H5 提交一致）。创建于 2026-10-12 */
    async openApprovalFlow() {
      if (!this.schoolId) {
        this.$message.warning('请先选择学校')
        return
      }
      this.flowVisible = true
      this.flowLoading = true
      this.flowProcessId = ''
      this.flowNodes = []
      try {
        const [flowRes, teacherRes] = await Promise.all([
          getLeaveApprovalProcessListPage({ page: 1, intPageSize: 50, departmentId: this.schoolId, usingTypes: TEMP_FLOW_USING_TYPE }),
          getTeacherMasterList({ departmentId: this.schoolId })
        ])
        this.flowTeachers = (teacherRes.data && teacherRes.data.success && teacherRes.data.response) || []
        const flows = ((flowRes.data && flowRes.data.response && flowRes.data.response.data) || [])
          .filter(x => String(x.DepartmentId) === String(this.schoolId))
          .sort((a, b) => (a.Sort || 0) - (b.Sort || 0))
        if (!flows.length) {
          this.flowNodes = [this.newFlowNode('classTeacher')]
          return
        }
        this.flowProcessId = String(flows[0].Id)
        const officerRes = await getProcessOfficer({ processId: this.flowProcessId })
        const officers = toCamel((officerRes.data && officerRes.data.response) || [])
        this.flowNodes = officers.map(o => ({
          role: o.role === 'classTeacher' ? 'classTeacher' : 'specificPerson',
          nodeName: o.nodeName || '',
          specificUsers: String(o.specificPerson || '').split('|').map(s => s.trim()).filter(Boolean)
        }))
        this.ensureFlowTeacherOptions()
      } catch (e) {
        this.$message.error('审批流程加载失败')
      } finally {
        this.flowLoading = false
      }
    },
    /** 已保存的审批人不在当前教职工列表（如已离职）时补入选项，避免下拉显示裸 Id */
    ensureFlowTeacherOptions() {
      const exist = new Set(this.flowTeachers.map(u => String(u.Id)))
      this.flowNodes.forEach(node => {
        node.specificUsers.forEach(id => {
          if (exist.has(id)) return
          this.flowTeachers.push({ Id: id, TeacherName: `教职工(${id})` })
          exist.add(id)
        })
      })
    },
    newFlowNode(role) {
      return { role, nodeName: role === 'classTeacher' ? '班主任审批' : '', specificUsers: [] }
    },
    addFlowNode() {
      this.flowNodes.push(this.newFlowNode(this.hasClassTeacherNode ? 'specificPerson' : 'classTeacher'))
    },
    removeFlowNode(index) {
      this.flowNodes.splice(index, 1)
    },
    flowRoleChange(node) {
      node.specificUsers = []
      node.nodeName = node.role === 'classTeacher' ? '班主任审批' : ''
    },
    flowUsersChange(node) {
      const ids = new Set(node.specificUsers)
      const names = this.flowTeachers.filter(u => ids.has(String(u.Id))).map(u => u.TeacherName)
      if (names.length) node.nodeName = `${names.join('、')}审批`
    },
    /** 保存审批流程：本校无流程时先创建，再整体覆盖审批节点。创建于 2026-10-12 */
    async saveApprovalFlow() {
      if (!this.flowNodes.length) {
        this.$message.warning('请至少添加一个审批节点')
        return
      }
      const emptyIndex = this.flowNodes.findIndex(n => n.role === 'specificPerson' && !n.specificUsers.length)
      if (emptyIndex >= 0) {
        this.$message.warning(`节点 ${emptyIndex + 1} 请选择审批人`)
        return
      }
      this.flowSaving = true
      try {
        if (!this.flowProcessId) {
          const addRes = await addLeaveApprovalProcess({
            Name: '停车场临时车审批',
            UsingType: TEMP_FLOW_USING_TYPE,
            DepartmentId: this.schoolId,
            Sort: 1
          })
          if (!(addRes.data && addRes.data.success)) {
            this.$message.error((addRes.data && addRes.data.msg) || '创建审批流程失败')
            return
          }
          this.flowProcessId = String(addRes.data.response)
        }
        const res = await addProcessOfficer({
          processId: this.flowProcessId,
          processOfficerDetails: this.flowNodes.map((n, i) => ({
            index: i + 1,
            nodeName: n.nodeName || (n.role === 'classTeacher' ? '班主任审批' : `审批节点${i + 1}`),
            role: n.role,
            specificUsers: n.role === 'specificPerson' ? n.specificUsers : [],
            days: 0
          }))
        })
        if (res.data && res.data.success) {
          this.$message.success('审批流程已保存')
          this.flowVisible = false
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.flowSaving = false
      }
    }
  }
}
</script>

<style>
@import './parking-page.css';

.flow-node-table {
  margin-top: 12px;
}
.flow-node-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.flow-node-table .el-button--text.is-danger {
  color: #f56c6c;
}

.invite-list-dialog {
  max-width: 96vw;
}

.invite-ops {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
}

.invite-ops .el-button + .el-button {
  margin-left: 0;
}

.invite-ops .is-warning {
  color: #e6a23c;
}

.invite-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.invite-result .qr-canvas {
  display: block;
}

.invite-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
